// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  sectionWrapper: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  sectionTitle: {
    fontWeight: 'bold',
  },
  summaryBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  overrideTypeText: {
    fontWeight: 'bold',
  },
  valueRow: {
    color: theme.palette.text.primary,
  },
  computedCostText: {
    fontWeight: 'bold',
  },
  mutedText: {
    color: theme.palette.text.secondary,
  },
  notesText: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  buttonRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  historyList: {
    listStyle: 'none',
    paddingLeft: theme.spacing(1),
    margin: 0,
  },
  historyItem: {
    fontSize: '13px',
  },
  historyNotes: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    paddingLeft: theme.spacing(2),
  },
  confirmContainer: {
    width: '480px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  },
  closeButton: {
    color: 'grey',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
});

export default styles;
